import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../utils/api";
import "../styling/login.css";
import LoadingMask from "../components/LoadingMask";
import FlashMessage from "../components/FlashMessage";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState("");
  const [flashType, setFlashType] = useState("success");
  const { login, user, authLoading } = useAuth();

  useEffect(() => {
    if (authLoading) return;
    if (user) navigate("/loanlist", { replace: true });
  }, [user, authLoading, navigate]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFlashMessage("");
    try {
      const res = await API.post("/auth/login", form);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      login(res.data.user, res.data.token);
      setFlashType("success");
      setFlashMessage("Welcome back! Redirecting...");
      setTimeout(() => navigate("/loanlist"), 600);
    } catch (err) {
      setFlashType("error");
      setFlashMessage("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <FlashMessage message={flashMessage} type={flashType} duration={3000} onClose={() => setFlashMessage("")} />
      {loading && <LoadingMask text="Authenticating..." />}

      <div className="login-card">
        <h2>Welcome Back</h2>
        <p className="login-subtitle">Sign in to your loan management account</p>

        <form autoComplete="off" onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email address"
            autoComplete="new-email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="forgot-password" onClick={() => navigate("/forgot-password")}>
          Forgot your password?
        </p>

        <div className="register-link">
          <p>Don't have an account? Contact administrator</p>
          <hr />
          <b>
            <p>murariraj.one@gmail.com</p>
            <p>+91 7799169804</p>
          </b>
        </div>
      </div>
    </div>
  );
};

export default Login;
